import { Tabs, withStyles } from '@material-ui/core';

const YellowTabs = withStyles({
    root: {
        color: '#FFFF',
        opacity: 1,
        background: '#098442 0% 0% no-repeat padding-box',
        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
        borderRadius: '4px 4px 0px 0px',
    },
    indicator: {
        backgroundColor: '#FFDD00',
    },
})(Tabs);

export default YellowTabs;
